import * as d3 from 'd3';
import { createNewItem, select } from '../canvasSlice';
import store from '../store';
import { addToStack, getPositionInScene } from '../Util';
import * as msc from "mascot-vis";

export const mouseDown = (e, scene) => {

}

export const mouseUp = (e, scene, datasets, renderer, undoStack) => {
    const p = getPositionInScene(e.clientX, e.clientY);
    let item = msc.hitTest(scene, p[0], p[1]);
    if (!item && d3.select("#textElement").style("visibility") === "visible") {
        d3.select("#textElement").style("visibility", "hidden");
        renderer.render(scene);
        return;
    }
    if (!item || item.type !== "pointText") {
        addToStack(scene, datasets, undoStack);
        item = scene.mark("text", {x: e.clientX, y: e.clientY, text: "", anchor: ["left", "top"]});
        store.dispatch(createNewItem(item.id));
        renderer.render(scene);
    }
    //show editing input
    d3.select("#textElement").style("visibility", "visible").style("left", item.bounds.left+"px").style("top", (item.bounds.top - 1)+"px")
        .property("value", item.text).style("font-family", item.fontFamily)
        .style("font-size", item.fontSize+"px").style("font-weight", item.fontWeight).style("height", item.bounds.height)
        .on("input", (e) => {item.text = d3.select("#textElement").property("value")})
        .on("focus", (e) => { store.dispatch(select([])); });
    document.getElementById("textElement").focus();
}